import React from 'react';
import HomeNav from '../Home/HomeNav';
import HomeFooter from '../Home/HomeFooter';
import CaseStudiesIntro from './CaseStudiesIntro';
import CaseStudiesList from './CaseStudiesList';
const CaseStudies = () => {
  return <div className='font-figtree' data-sentry-component="CaseStudies" data-sentry-source-file="CaseStudies.jsx">
      <HomeNav data-sentry-element="HomeNav" data-sentry-source-file="CaseStudies.jsx" />
      <CaseStudiesIntro data-sentry-element="CaseStudiesIntro" data-sentry-source-file="CaseStudies.jsx" />
      <CaseStudiesList data-sentry-element="CaseStudiesList" data-sentry-source-file="CaseStudies.jsx" />
      <HomeFooter data-sentry-element="HomeFooter" data-sentry-source-file="CaseStudies.jsx" />
    </div>;
};
export default CaseStudies;